// src/components/ui/Label.jsx
import React from "react";
import { cn } from "../../utils/cn";

const Label = React.forwardRef(({ className, error, ...props }, ref) => (
  <label
    ref={ref}
    className={cn(
      "block text-label-medium font-afrimed-medium",
      error ? "text-afrimed-error" : "text-afrimed-on-surface",
      className
    )}
    {...props}
  />
));

Label.displayName = "Label";
export default Label;